import { Link } from 'react-router-dom';
import setUiMessage from '../../../Utilities/Tostify';
import { post } from '../../Auths/AuthToken';

// Generic Document Tab Component
const DocumentTab = ({
  patientId = false,
  classActive,
  tabId,
  title,
  icon,
  data,
  selectedChildDocs,
  toggleDocSelection,
  dateFilterEnabled = true,
  filterState = {},
  onDateChange = () => {},
  handleReload = () => {},
}) => {
  const { filterType, startDate, endDate } = filterState;

  const getDate90DaysAgo = () => {
    const today = new Date();
    today.setDate(today.getDate() - 90);

    // Format to YYYY-MM-DD
    // return today.toISOString().split('T')[0];
    return today.toLocaleDateString('en-CA'); // gives YYYY-MM-DD
  };
  const getToday = () => {
    return new Date().toLocaleDateString('en-CA'); // YYYY-MM-DD
  };

  const handleFilterChange = (value) => {
    if (value !== 'range') {
      onDateChange({
        filterType: value,
        startDate: '',
        endDate: '',
      });
    } else
      onDateChange({
        filterType: value,
        startDate,
        endDate,
      });
  };

  const handleDateChange = (type, value) => {
    onDateChange({
      filterType: 'range',
      startDate: type === 'start' ? value : startDate,
      endDate: type === 'end' ? value : endDate,
    });
  };

  const generateFaceSheet = async () => {
    try {
      if (patientId) {
        const response = await post('api/commonTask/generateFaceSheet', {
          patientId: patientId,
        });
        if (response.status === 200) {
          handleReload();
        }
      }
    } catch (error) {
      setUiMessage('err', error.message);
    }
  };

  return (
    <div className={`tabContainer__content flex-1 ${classActive}`} id={tabId}>
      <div className="p-4 border-b-1 border-b-lightgray">
        <h3 className="fw-400 fs-md mb-5">{title}</h3>
        {!dateFilterEnabled && (
          <button
            className="tabContainer__generate border border-lightgray cursor-pointer rounded-md p-2 mb-4"
            onClick={generateFaceSheet}
          >
            Generate Face Sheet
          </button>
        )}
        {dateFilterEnabled && (
          <div className="tabContainer__radio flex flex-col gap-3 ml-1">
            <p className="text-black">Load documents based on dates:</p>
            <div className="flex justify-between">
              <div className="flex items-center gap-3">
                <label className="fs-xs pb-0">
                  <input
                    type="radio"
                    name={`${tabId}DateFilter`}
                    value="all"
                    checked={filterType === 'all'}
                    onChange={() => handleFilterChange('all')}
                  />
                  <span>All</span>
                </label>
                <label className="fs-xs pb-0">
                  <input
                    type="radio"
                    name={`${tabId}DateFilter`}
                    value="90days"
                    checked={filterType === '90days'}
                    onChange={() => handleFilterChange('90days')}
                  />
                  <span>90 days</span>
                </label>
                <label className="fs-xs pb-0">
                  <input
                    type="radio"
                    name={`${tabId}DateFilter`}
                    value="range"
                    checked={filterType === 'range'}
                    onChange={() => handleFilterChange('range')}
                  />
                  <span>Date range</span>
                </label>
              </div>
              {filterType !== '90days' && (
                <div className="flex gap-2">
                  <div className="flex flex-col gap-1">
                    <label className="pb-0">Start date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={startDate}
                      disabled={filterType !== 'range'}
                      onChange={(e) =>
                        handleDateChange('start', e.target.value)
                      }
                    />
                  </div>
                  <div className="flex flex-col gap-1">
                    <label className="pb-0">End date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={endDate}
                      disabled={filterType !== 'range'}
                      onChange={(e) => handleDateChange('end', e.target.value)}
                    />
                  </div>
                </div>
              )}
              {filterType === '90days' && (
                <div className="flex gap-2">
                  <div className="flex flex-col gap-1">
                    <label className="pb-0">Start date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={getDate90DaysAgo()}
                      onChange={(e) => {}}
                      disabled={true}
                    />
                  </div>
                  <div className="flex flex-col gap-1">
                    <label className="pb-0">End date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={getToday()}
                      onChange={(e) => {}}
                      disabled={true}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      <div className="p-4 tabContainer__scrollbar">
        <div className="tabContainer__list flex flex-col gap-3">
          {data && data.length > 0 ? (
            data.map((doc) => {
              const docKey = `${tabId}_${doc.id}`;
              // const jsonStr = JSON.stringify(doc);

              return (
                <div
                  className="tabContainer__item flex items-center gap-2 p-2 border border-lightgray fs-xs rounded-md cursor-pointer"
                  key={docKey}
                  data-block={tabId}
                >
                  <input
                    type="checkbox"
                    checked={!!selectedChildDocs[docKey]}
                    onChange={(event) => toggleDocSelection(event, docKey, doc)}
                    disabled={
                      tabId === 'progressNotes' && doc?.sign_status !== '1'
                    }
                  />
                  <div
                    className={`tabContainer__icon ${doc.iconClass} flex items-center justify-center rounded-md`}
                  >
                    <img
                      src={icon}
                      width="15"
                      alt=""
                      onClick={() => {
                        if (tabId === 'progressNotes') {
                          if (doc?.file_url) {
                            window.open(doc.file_url, '_blank');
                          }
                        }
                      }}
                    />
                  </div>
                  <div className="tabContainer__info flex flex-col">
                    <span className="linkColor">
                      {doc?.file_url && tabId !== 'progressNotes' ? (
                        <Link to={doc.file_url} target="_blank">
                          {(tabId === 'patientFaceSheet' &&
                            'Patient Demographics & Contact Information') ||
                            (tabId === 'results' && doc?.procedure_name) ||
                            (tabId === 'documentss' && doc?.doc_name) ||
                            (tabId === 'progressNotes' && doc?.tovName) ||
                            (tabId === 'clinicalSummary' && 'Clinical Summary')}
                        </Link>
                      ) : (
                        (tabId === 'patientFaceSheet' &&
                          'Patient Demographics & Contact Information') ||
                        (tabId === 'results' && doc?.procedure_name) ||
                        (tabId === 'documentss' && doc?.doc_name) ||
                        (tabId === 'progressNotes' && doc?.tovName) ||
                        (tabId === 'clinicalSummary' && 'Clinical Summary')
                      )}
                    </span>
                    {tabId === 'results' && (
                      <span className="fs-xxs text-gray leading-normal">
                        {doc?.facility_name}
                      </span>
                    )}
                    {
                      <span className="fs-xxs text-gray">
                        {tabId === 'patientFaceSheet' && doc.added_date}
                        {tabId === 'results' &&
                          `Result Date: ${doc.date_added}`}
                        {tabId === 'documentss' &&
                          `Document Date: ${doc.doc_date}`}
                        {tabId === 'progressNotes' &&
                          `Service Date: ${doc.consult_date}`}
                        {tabId === 'clinicalSummary' &&
                          `Generated: ${doc.date_added}`}
                        {/* {doc.date_added || doc.added_date} */}
                      </span>
                    }
                    {doc.providerName && (
                      <span className="fs-xxs text-gray">
                        Provider: {doc.providerName}
                      </span>
                    )}
                    {doc.sign_status && (
                      <div className="flex items-center gap-2">
                        <span className="fs-xxs text-gray">
                          Status:{' '}
                          {doc.sign_status === '1' ? 'Signed' : 'Not Signed'}
                        </span>
                        {doc.sign_status === '1' && (
                          <img src="./images/check.svg" width="15" alt="" />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <div className="text-center text-gray">No documents found.</div>
          )}
        </div>
      </div>
    </div>
  );
};
export default DocumentTab;
